import validate from "/home/yuyue/Documents/embbay/node_modules/.pnpm/nuxt@3.8.2_@types+node@18.18.13_typescript@5.2.2_vite@4.5.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/yuyue/Documents/embbay/node_modules/.pnpm/nuxt@3.8.2_@types+node@18.18.13_typescript@5.2.2_vite@4.5.2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}